import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';


interface IProps {
  bestMoments: any;
  }


  const BestMoment = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { bestMoments } = props;

    const [bmcommentary, setBmcommentary] = useState("Analyzing...");
    const [displaySecond, setDisplaySecond] = useState(":00");
    

    useEffect(() => {
        if (bestMoments?.length >= 1) {
          
          const item = bestMoments[0];
          //setBestSingleItem(item);
          const ds = ("0" + item.epoch_start).slice(-2);
          setDisplaySecond(ds);
          setBmcommentary(`Your best moment in this content was at :${ds} of the experience. Now that you know where brains are most connected to the content, you should check that your call to action is happening in this spot.`);  

        }
      }, [props]);
    
      const goToAnalyze = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };

    //console.log(`i score immersiondata = ${JSON.stringify(immersionData)}`);


    return (

        <Grid item xs={4} style={{textAlign: 'center'}} >
            <Typography variant="h1" color={'primary'} className={classes.itemtitle}>:{!!displaySecond ? displaySecond : "00"}</Typography>
            <Typography variant="body1" className={classes.sectionTitle}>Best Moment</Typography>
            <Typography variant="body1" className={classes.bodyText}>{bmcommentary}</Typography>
            <Link className={classes.actionLink} onClick={goToAnalyze}>
                <Typography variant="body1" className={classes.foo}>See the Best Moment</Typography>
            </Link>
          </Grid>

    )


  }

  export default BestMoment;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));